import {
    IServicesNomenclaturesTree,
    IServicesTreeItem,
    ServicesNomenclaturesTreeResponseType
} from "@/entity/servicesNomenclature/services.nomenclature.types";

export default class ServicesNomenclaturesTree implements IServicesNomenclaturesTree {
    key: number;
    title: string; // Название категории услуги
    children: IServicesTreeItem[] = []
    constructor(data: ServicesNomenclaturesTreeResponseType) {
        this.key =  data.id;
        this.title = data.name;
        for (let i = 0; i < data.services.length; i++) {
            this.children.push({
                key: data.id + '-' + data.services[i].id,
                title: data.services[i].name,
                category_id: data.services[i].category_id,
            });
        }
    }
}